import { ColumnDef } from '@tanstack/react-table';
import { SocialAccountData } from './social-accounts-table-types';

export const socialAccountsTableColumns: ColumnDef<SocialAccountData>[] = [
  {
    accessorKey: 'memberName',
    header: 'Member',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 200,
    rowType: 'memberName',
    id: 'memberName',
  },
  {
    accessorKey: 'socialAccount',
    header: 'Social Handle',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 150,
    rowType: 'socialAccount',
    id: 'socialAccount',
  },
  {
    accessorKey: 'roas',
    header: 'ROAS',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
    rowType: 'roas',
    id: 'roas',
  },
  {
    accessorKey: 'impressions',
    header: 'Impression',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 130,
    rowType: 'impressions',
    id: 'impressions',
  },
  {
    accessorKey: 'reach',
    header: 'Reach',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 130,
    rowType: 'reach',
    id: 'reach',
  },
  {
    accessorKey: 'clicks',
    header: 'Click',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
    rowType: 'clicks',
    id: 'clicks',
  },
  {
    accessorKey: 'ctr',
    header: 'CTR',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
    rowType: 'ctr',
    id: 'ctr',
  },
  {
    accessorKey: 'cpm',
    header: 'CPM',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
    rowType: 'cpm',
    id: 'cpm',
  },
  {
    accessorKey: 'cpc',
    header: 'CPC',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
    rowType: 'cpc',
    id: 'cpc',
  },
  {
    accessorKey: 'spend',
    header: 'Spend',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 120,
    rowType: 'spend',
    id: 'spend',
  },
  {
    accessorKey: 'sales',
    header: 'Sales',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 120,
    rowType: 'sales',
    id: 'sales',
  },
] as (import('@tanstack/react-table').ColumnDef<SocialAccountData> & { rowType: string; id: string })[];

// Default column order for column ordering functionality
export const defaultColumnOrder = [
  'memberName',
  'socialAccount',
  'roas',
  'impressions',
  'reach',
  'clicks',
  'ctr',
  'cpm',
  'cpc',
  'spend',
  'sales',
];
